import ExcelJS from "exceljs";

export async function createShipmentExcel(data) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("발송현황");

  // 택배사 옵션 (택배사명만)
  const courierOptions = [
    "우체국택배",
    "CJ대한통운",
    "한진택배",
    "로젠택배",
    "롯데택배",
    "일양로지스",
    "한의사랑택배",
    "천일택배",
    "건영택배",
    "한진택배B2B",
    "대신택배",
    "경동택배",
    "GS Postbox 택배",
    "합동택배",
    "애니트랙",
    "SLX택배",
    "우리택배(구호남택배)",
    "CU편의점택배",
    "우리한방택배",
    "농협택배",
    "홈픽택배",
    "IK물류",
    "성훈물류",
    "CR로지텍",
    "용마로지스",
    "원더스퀵",
    "컬리넥스트마일",
    "풀앳홈",
    "두발히어로",
    "위니아딤채",
    "지니고 당일배송",
    "카카오 T 당일배송",
    "트랙스로지스",
    "나은물류",
    "한샘서비스",
    "도도플렉스(dodoflex)",
    "LG전자",
    "1004홈",
    "썬더히어로",
    "롯데칠성",
    "핑퐁",
    "발렉스 특수물류",
    "엔티엘피스",
    "지케이글로벌",
    "로지스팟",
    "홈픽 오늘도착",
    "로지스파트너",
    "딜리래빗",
    "지오피",
    "에이치케이홀딩스",
    "HTNS",
    "케이제이티",
    "더바오",
    "라스트마일",
    "탱고앤고",
    "투데이",
    "현대글로비스",
    "ARGO(테크타카)",
    "HY",
    "유피로지스(제주)",
    "반얀로지스틱스",
    "삼다수 가정배송",
    "와이드테크",
    "위니온",
    "딜리박스",
    "이스트라",
    "유피로지스",
    "올인닷컴",
    "물류대장(택배)",
    "풀무원샘물㈜",
    "SLO(모든)",
    "바로스",
    "레터스",
    "벤더피아",
    "세븐일레븐 착한택배",
    "물류대장(설치)",
    // 국제택배
    "EMS",
    "DHL",
    "UPS",
    "Fedex",
    "TNT Express",
    "USPS",
    "GSMNtoN",
    "KGL네트웍스",
    "LX판토스",
    "ECMS Express",
    "GSI Express",
    "CJ대한통운 국제특송",
    "ACI Express",
    "A.C.E EXPRESS INC",
    "GPS Logix",
    "성원글로벌카고",
    "EuroParcel",
    "YJS글로벌(영국)",
    "은하쉬핑",
    "YJS글로벌(월드)",
    "Giant Network Group",
    "대림통운",
    "LOTOS CORPORATION",
    "LineExpress",
    "제니엘시스템",
    "스마트로지스",
    "이투마스(ETOMARS)",
    "하이브시티",
    "팬스타국제특송(PIEX)",
    "에이씨티앤코아물류",
    "롯데택배 해외특송",
    "SHIPNERGY",
    "브릿지로지스㈜",
    "MEXGLOBAL",
    "캐나다쉬핑",
    "YUNDA EXPRESS",
    "바바바(bababa)",
    "BAIMA EXPRESS",
    "LTL",
    "판월드로지스틱",
    "직구문",
    "인터로지스",
    "큐브플로우(CUBEFLOW)",
    "국제로지스틱(KSE)",
    "에스더쉬핑",
    "골드스넵스",
    "자이언트",
    "엠티인터내셔널",
    "이지로지스틱",
    "케이티익스프레스",
    "AusPost",
    "SAP EXPRESS",
    "서림특송",
    "Rincos",
    "JNT",
    "티에스지로지스",
    "지씨에스",
    "윤익스프레스(YunExpress)",
    "CXCExpress",
  ];
  // 윈도우에서 파일 손상 오류 뜨는 거 해결
  // 1) 숨김 시트 생성
  const hiddenSheet = workbook.addWorksheet("couriers", {
    state: "veryHidden",
  });

  // 2) 리스트 값 넣기 (A열)
  hiddenSheet.getColumn(1).values = [null, ...courierOptions];

  // 헤더 설정
  worksheet.columns = [
    { header: "고유식별번호", key: "id", width: 40 },
    { header: "닉네임", key: "nickname", width: 15 },
    { header: "받는사람이름", key: "receiver_name", width: 15 },
    { header: "받는사람연락처", key: "receiver_phone", width: 15 },
    { header: "받는사람국가", key: "receiver_country", width: 10 },
    { header: "받는사람주소", key: "receiver_street_address", width: 30 },
    { header: "받는사람상세주소", key: "receiver_address_line", width: 25 },
    { header: "받는사람도시", key: "receiver_city", width: 15 },
    { header: "받는사람시도", key: "receiver_state_province", width: 15 },
    { header: "받는사람우편번호", key: "receiver_postal_code", width: 15 },
    { header: "통관고유번호", key: "customs_clearance_number", width: 20 },
    { header: "배송메시지", key: "delivery_message", width: 30 },
    { header: "택배사", key: "courier_company", width: 25 },
    { header: "보내는사람이름", key: "sender_name", width: 15 },
    { header: "보내는사람연락처", key: "sender_phone", width: 15 },
    { header: "운송장번호", key: "tracking_number", width: 20 },
    { header: "상품명", key: "product_name", width: 20 },
    { header: "상품코드", key: "product_code", width: 15 },
    { header: "상품옵션", key: "product_option", width: 20 },
    { header: "수량", key: "quantity", width: 10 },
  ];

  // 데이터 추가
  data.result.forEach((item, index) => {
    const rowIndex = index + 2; // 헤더 다음부터 시작 (1-based index)

    worksheet.addRow({
      id: item.id,
      nickname: item.nickname,
      courier_company: item.courier_company || "",
      tracking_number: item.tracking_number || "",
      product_code: "",
      product_name: "",
      product_option: "",
      quantity: "",
      sender_name: item.sender_name || "",
      sender_phone: item.sender_phone || "",
      receiver_name: item.receiver_name,
      receiver_phone: item.receiver_phone,
      receiver_country: item.receiver_country,
      receiver_street_address: item.receiver_street_address,
      receiver_address_line: item.receiver_address_line,
      receiver_city: item.receiver_city,
      receiver_state_province: item.receiver_state_province,
      receiver_postal_code: item.receiver_postal_code,
      customs_clearance_number: item.customs_clearance_number || "N/A",
      delivery_message: item.delivery_message,
    });

    // 각 셀에 직접 텍스트 포맷 설정 (컬럼 레벨 설정이 작동하지 않을 수 있어서)
    // 받는사람연락처 (D열, 4번째 컬럼)
    worksheet.getCell(`D${rowIndex}`).numFmt = "@";
    worksheet.getCell(`D${rowIndex}`).value = String(item.receiver_phone || "");

    // 보내는사람연락처 (O열, 15번째 컬럼)
    worksheet.getCell(`O${rowIndex}`).numFmt = "@";
    worksheet.getCell(`O${rowIndex}`).value = String(item.sender_phone || "");

    // 운송장번호 (P열, 16번째 컬럼)
    worksheet.getCell(`P${rowIndex}`).numFmt = "@";
    worksheet.getCell(`P${rowIndex}`).value = String(
      item.tracking_number || ""
    );

    // 택배사 컬럼(M열, 13번째 컬럼)에 드롭다운 설정
    worksheet.getCell(`M${rowIndex}`).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [`=couriers!$A$2:$A$${courierOptions.length + 1}`],
      showErrorMessage: true,
      errorStyle: "error",
      errorTitle: "잘못된 선택",
      errorBody: "목록에서 택배사를 선택해주세요.",
    };

    // 수량 컬럼(T열, 20번째 컬럼)에 숫자만 입력 가능하도록 설정
    worksheet.getCell(`T${rowIndex}`).dataValidation = {
      type: "whole",
      operator: "greaterThanOrEqual",
      formulae: [0],
      showErrorMessage: true,
      errorStyle: "error",
      errorTitle: "잘못된 입력",
      errorBody: "수량은 0 이상의 숫자만 입력 가능합니다.",
    };
  });

  // 전체 데이터 범위에 테두리 적용
  const rowCount = data.result.length + 1;
  const colCount = worksheet.columns.length;

  for (let row = 1; row <= rowCount; row++) {
    for (let col = 1; col <= colCount; col++) {
      const cell = worksheet.getCell(row, col);
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      if (row === 1) {
        cell.font = { bold: true };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };
      } else {
        const userInputColumns = [13, 14, 15, 16, 17, 18, 19, 20];

        if (!userInputColumns.includes(col)) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFEF9E7" },
          };
        }
      }
    }
  }

  // 여기 바꿔서 다운받게 해야 함
  // const filename = `지원자운송장등록.xlsx`;
  // await workbook.xlsx.writeFile(filename);

  // return filename;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "지원자운송장등록.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
}
